module.exports = __webpack_public_path__ + "img/4ENG_Cover.cb745dc0.jpg";